export const JSON_ONE4NW = {

    "ag_id": "paygate",
"me_id":"202205240004",
"order_no": "HhFd/cICIkddL3MqrXxMA==",
"ag_ref": "pHhFd/csdUICIkddL3MqrXxMA="


};